import { Button } from 'antd'
import { toNumber } from 'lodash'

import { pick } from '@eastcoal/common/utils/object'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'
import { useAuctionListStore } from '../../../Store/hooks/useStore'

import { AuctionDetailButtonProps } from './interface'

export const AuctionDetailButton = ({ record }: AuctionDetailButtonProps) => {
  const { setCurrentAuction, toggleDetailFormVisible } = useAuctionListStore(
    state => pick(state, ['setCurrentAuction', 'toggleDetailFormVisible'])
  )

  const handleClick = () => {
    setCurrentAuction(record)
    toggleDetailFormVisible(true)
  }

  const status = toNumber(record.status)

  return status === AuctionMemberPageStatus.WAIT_PUBLISH ? (
    <Button type='link' onClick={handleClick}>
      查看详情
    </Button>
  ) : null
}
